import { SelectActiveUserGroupWithBranchNameOutputDataBranchDetail } from './select-active-user-group-with-branch-name-output-data-branch-detail.model';


export class SelectActiveUserGroupWithBranchNameOutputData implements ISelectActiveUserGroupWithBranchNameOutputData {
    /** The auto-generated id of the user group master */
    user_group_id!: number;
    /** The user group name with 255 character limit */
    user_group_name!: string;
    /** The auto-generated id of the user type master */
    user_type_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    branch_detail!: SelectActiveUserGroupWithBranchNameOutputDataBranchDetail[];

    constructor(data?: ISelectActiveUserGroupWithBranchNameOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_group_id = _data["user_group_id"];
            this.user_group_name = _data["user_group_name"];
            this.user_type_id = _data["user_type_id"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            if (Array.isArray(_data["branch_detail"])) {
                this.branch_detail = [] as any;
                for (let item of _data["branch_detail"])
                    this.branch_detail!.push(SelectActiveUserGroupWithBranchNameOutputDataBranchDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectActiveUserGroupWithBranchNameOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new SelectActiveUserGroupWithBranchNameOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_group_id"] = this.user_group_id;
        data["user_group_name"] = this.user_group_name;
        data["user_type_id"] = this.user_type_id;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        if (Array.isArray(this.branch_detail)) {
            data["branch_detail"] = [];
            for (let item of this.branch_detail)
                data["branch_detail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISelectActiveUserGroupWithBranchNameOutputData {
    /** The auto-generated id of the user group master */
    user_group_id: number;
    /** The user group name with 255 character limit */
    user_group_name: string;
    /** The auto-generated id of the user type master */
    user_type_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    branch_detail: SelectActiveUserGroupWithBranchNameOutputDataBranchDetail[];
}

